import { isHtmlImageTag } from 'modules/dynamicContentBuilder/utils';
import { isHandlebarsSnippetTag } from 'modules/dynamicContentBuilder/utils/isHandlebarsSnippetTag';
import { useContentController } from '../../../hooks/form';
import { ClearContentButton } from './ClearContentButton';
import { CustomTextInput } from './CustomTextInput';
import { ImagePreview } from './ImagePreview';
import { SnippetPreview } from './SnippetPreview';

const getContentPreview = (content: string) => {
  if (isHtmlImageTag(content)) {
    return <ImagePreview />;
  }

  if (isHandlebarsSnippetTag(content)) {
    return <SnippetPreview />;
  }

  return <CustomTextInput />;
};

export const SelectedContent = () => {
  const {
    field: { onChange, value: content = '' },
  } = useContentController();
  const clearContent = () => onChange(undefined);
  const contentPreview = getContentPreview(content);

  return (
    <>
      {contentPreview}
      <ClearContentButton onClick={clearContent} />
    </>
  );
};
